const Enum = require('./Enum').default;

const EntityType = new Enum({
  'State Police': 0,
  'Sheriff': 1,
  'Municipal Police': 2,
  'Firefighter': 3,
  'First Responder - Other': 4,
  'DOTD': 5,
  'Maintenance - Other': 6
});

module.exports = {
  EntityType
};